import { useTranslation } from 'react-i18next';

export default function Hero() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full min-h-[520px] md:min-h-[620px] flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Vibrant%20curated%20product%20marketplace%20scene%20with%20diverse%20fashion%20sneakers%20hoodies%20bags%20and%20accessories%20artistically%20arranged%20on%20warm%20terracotta%20and%20sand%20colored%20surfaces%2C%20natural%20window%20light%20casting%20beautiful%20shadows%2C%20rich%20earthy%20tones%2C%20modern%20editorial%20product%20photography%2C%20European%20boutique%20aesthetic%2C%20dynamic%20composition%20with%20depth%20and%20layers%2C%20sophisticated%20retail%20display%20inspiration&width=1600&height=800&seq=hero-kakobuy-2026-v3&orientation=landscape')`,
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/45"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-8 text-center">
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-4 leading-tight">
          {t('hero.title')}
        </h1>
        <p className="font-heading text-xl md:text-2xl text-white/90 mb-3 font-medium">
          {t('hero.subtitle')}
        </p>
        <p className="text-sm md:text-base text-white/75 max-w-2xl mx-auto mb-8 leading-relaxed">
          {t('hero.description')}
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-background-50 rounded-full text-sm md:text-base font-semibold hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer inline-flex items-center justify-center gap-2"
          >
            <i className="ri-external-link-line"></i>
            {t('hero.cta_primary')}
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 bg-accent-500 text-background-50 rounded-full text-sm md:text-base font-semibold hover:bg-accent-600 transition-all duration-300 whitespace-nowrap cursor-pointer inline-flex items-center justify-center gap-2"
          >
            <i className="ri-shopping-cart-line"></i>
            {t('hero.cta_secondary')}
          </a>
        </div>

        <div className="mt-6">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-6 py-2.5 bg-white/15 backdrop-blur-sm border border-white/25 text-white rounded-full text-sm font-medium hover:bg-white/25 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-file-list-3-line"></i>
            {t('hero.cta_kakobuy')}
          </a>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6 text-white/60 text-xs">
          <span className="flex items-center gap-1.5">
            <i className="ri-check-line text-primary-400"></i>
            {t('trust.updated')}
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-check-line text-primary-400"></i>
            {t('trust.free')}
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-check-line text-primary-400"></i>
            {t('trust.verified')}
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-check-line text-primary-400"></i>
            {t('trust.guides')}
          </span>
        </div>
      </div>
    </section>
  );
}